import {
  invalidateQueries,
  queryClient,
  queryKeys,
} from "@/shared/lib/queryClient";
import AuthService from "@/shared/services/AuthService";
import SocialAuthService from "@/shared/services/SocialAuthService";
import { useEffect, useRef } from "react";
import { VK_CODE_VERIFIER_KEY } from "./vkAuth";

const VK_CALLBACK_CODE = "code";
const VK_CALLBACK_STATE = "state";


function getSearchParam(search: string, key: string): string | null {
  const params = new URLSearchParams(search);
  const value = params.get(key);
  if (value == null) return null;
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function VkAuthCallbackHandler() {
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current || typeof window === "undefined") return;

    const search = window.location.search;

    const code = getSearchParam(search, VK_CALLBACK_CODE);
    if (!code) return;

    const codeVerifierFromState = getSearchParam(search, VK_CALLBACK_STATE);
    const codeVerifierFromStorage = localStorage.getItem(VK_CODE_VERIFIER_KEY);
    const codeVerifier = codeVerifierFromStorage || codeVerifierFromState;

    if (!codeVerifier) {
      console.warn(
        "VK auth callback: code_verifier not found (no state in URL and empty localStorage)",
      );
      return;
    }

    processedRef.current = true;
  
    const url = decodeURIComponent(window.location.href);
    
    SocialAuthService.vkAuth(url, codeVerifier)
      .then(async () => {
        try {
          localStorage.removeItem(VK_CODE_VERIFIER_KEY);
        } catch {
          // ignore
        }
        const cleanPath = window.location.pathname + window.location.hash;
        window.history.replaceState(null, "", cleanPath);

        const userData = await AuthService.checkAuth();
        queryClient.setQueryData(queryKeys.auth.me(), userData);
        invalidateQueries.auth();
      })
      .catch((error) => {
        console.error("VK auth callback error:", error);
        processedRef.current = false;
      });
  }, []);

  return null;
}
